import { mapActions } from 'vuex';
import { hCreateTimeInterval } from '@/utils/helpers';

export default {
  name: 'page-choose-date-and-time',
  props: ['widgetStyle', 'widgetConfig'],
  data() {
    return {
      selectedDate: null,
      selectedTime: null,
    };
  },
  computed: {
    style() {
      return {
        backgroundColor: this.widgetStyle.main_color,
        borderColor: this.widgetStyle.main_color,
      };
    },
    schedule() {
      return this.$store.getters.widgetSchedule;
    },
    timeScheduleForSelectedDay() {
      if (this.selectedDate) {
        const selectedDay = this.$store.getters.widgetSchedule.find(item => item.date === this.selectedDate);
        const { availableFrom, availableTo } = selectedDay;
        return hCreateTimeInterval(availableFrom, availableTo);
      }
      return [];
    },
  },
  methods: {
    ...mapActions(['toggleWidgetModal', 'sendOrderCallDisposition']),
    orderCall() {
      const orderedCallDate = `${this.selectedDate} ${this.selectedTime}:00`;
      this.sendOrderCallDisposition(orderedCallDate);
    },
  },
};
